import { configureStore } from "@reduxjs/toolkit";
import { analysisSlice } from "./context/analysisSlice";
import { projectInfoSlice } from "./context/projectInfoSlice";
import { defaultTabSlice } from "./context/defaultTabSlice";
import { contextBuilderSlice } from "./context/contextBuilderSlice";
import { imageAnalysisSlice } from "./context/imageAnalysisSlice";
import { themeSlice } from "./context/themeSlice";
import { feedbackSlice } from "./context/feedbackSlice";
import imageViewerSlice from "./comprehensiveImageViewer/imageViewerSlice";
import imageVCSlice from "./comprehensiveImageViewer/imageViewerlikeContext";
import {sosSodSlice} from "./context/sosSodSlice";

// planogram imports
import { planogramSlice } from "./planogram/planogramSlice";
import { planogramFeedbackSlice } from "./planogram/feedbackSlice";
import { planogramThemeSlice } from "./planogram/themeSlice";
import { planogramProjectInfoSlice } from "./planogram/projectInfoSlice";
import { planogramTabSlice } from "./planogram/planogramTabSlice"
import { planogramImageSlice } from "./planogram/planogramImageSlice";

//ShelfView imports
import { Thumbnails } from "./ShelfView/ThumbnailStore";
import { conflictData } from "./ShelfView/conflictSlice";
import { shelfViewFeedbackSlice } from "./ShelfView/feedback";
import popoverSlice from "./ShelfView/popover"
import pageSlice from "./ShelfView/conflictsPage"
import conflictThumbnailSlice from "./ShelfView/conflictThumbnail";

// motor insurance imports
import { miSlice } from "./motorInsurance/motorInsuranceSlice";
import { miImageSlice } from "./motorInsurance/miImageSlice";
import { miAuditSearchSlice } from "./motorInsurance/miAuditSearchSlice";

// global app imports
import { userSlice } from "./app/userSlice";

// populating store using slices, 
// this will provide a way to access store values...
export const store = configureStore({
  reducer: {
    analysisStore: analysisSlice.reducer,
    projectInfoStore: projectInfoSlice.reducer,
    defaultTabStore: defaultTabSlice.reducer,
    contextBuilderStore: contextBuilderSlice.reducer,
    imageAnalysisStore: imageAnalysisSlice.reducer,
    themeStore: themeSlice.reducer,
    feedbackStore: feedbackSlice.reducer,
     sosSodStore:sosSodSlice.reducer,


    planogramStore: planogramSlice.reducer,
    planogramThemeStore: planogramThemeSlice.reducer,
    planogramFeedbackStore: planogramFeedbackSlice.reducer,
    planogramProjectInfoStore: planogramProjectInfoSlice.reducer,
    planogramTabStore: planogramTabSlice.reducer,
    planogramImageStore: planogramImageSlice.reducer,

    imageViewerStore:imageViewerSlice,
    imageVCStore:imageVCSlice,

    
    
    thumbnailStore: Thumbnails.reducer,
    conflictDataStore: conflictData.reducer,
    shelfViewFeedbackStore: shelfViewFeedbackSlice.reducer,
    popoverStore:popoverSlice,
    conflictsPageStore:pageSlice,
    conflictThumbnailStore:conflictThumbnailSlice,

    userStore: userSlice.reducer,

    miStore: miSlice.reducer,
    miImageStore: miImageSlice.reducer,
    miAuditSearchStore: miAuditSearchSlice.reducer,
  }
})


// exporting actions for above slices...
// context builder slices
export const analysisActions = analysisSlice.actions;
export const projectInfoActions = projectInfoSlice.actions;
export const defaultTabActions = defaultTabSlice.actions;
export const contextBuilderActions = contextBuilderSlice.actions;
export const imageAnalysisActions = imageAnalysisSlice.actions;
export const themeActions = themeSlice.actions;
export const feedbackActions = feedbackSlice.actions;
export const sosAndSodActions = sosSodSlice.actions;

// planogram slices
export const planogramActions = planogramSlice.actions;
export const planogramFeedbackActions = planogramFeedbackSlice.actions;
export const planogramThemeActions = planogramThemeSlice.actions;
export const planogramProjectInfoActions = planogramProjectInfoSlice.actions;
export const planogramTabActions = planogramTabSlice.actions;
export const planogramImageActions = planogramImageSlice.actions;

//Shelf View
export const thumbnailStoreActions = Thumbnails.actions
export const conflictDataActions = conflictData.actions
export const shelfViewFeedbackActions = shelfViewFeedbackSlice.actions


// global app actions
export const userActions = userSlice.actions;

// motor insurance actions
export const miActions = miSlice.actions
export const miImageActions = miImageSlice.actions
export const miAuditSearchActions = miAuditSearchSlice.actions